import React from "react";
import { HomePreviewStationsLoaderTemplate } from "themes/application/home/components";

function HomePreviewStations(props) {
    return <HomePreviewStationsLoaderTemplate {...props} />;
}

export default HomePreviewStations;
